{
  "selectAsField": "选择“{value}”作为{fieldName}",
  "typeToSearchField": "输入以搜索{fieldName}",
  "licenseFieldLabel": "选择车牌号（例如 215BG2）",
  "licenseFieldName": "车牌号",
  "licensePlaceholder": "按车牌号搜索",
  "dotFieldLabel": "选择 DOT 编号",
  "dotFieldName": "DOT 编号",
  "dotPlaceholder": "按 DOT 编号搜索",
  "chooseOneOption": "请选择以下选项之一"
}
